/* cl-spec.js: Spec Pro product template (pilot, 2026-10). No dependencies.
   - Color swatches drive the real variant input (name="id"), the [data-variant] JSON Hulk reads, price, SKU,
     material line, gallery photo, size-drawing color, sticky bar and ?variant= in the URL.
   - Volume tiers are read from the live HulkApps table rendered into .hulkapps-volumes (hidden). If Hulk never
     renders, no tiers are shown (the plain price stays). Hulk counts every color of this product together.
   - Add to cart posts the normal product form to /cart/add.js and fires the theme's 'product:added' event,
     so the Warehouse cart drawer opens exactly as on other product pages. Without JS the form posts normally. */
(function () {
  'use strict';
  var root = document.getElementById('cls');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse((document.getElementById('cls-cfg') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
  var COUNT = parseInt(root.getAttribute('data-count'), 10) || cfg.count || 0;
  var UNIT = root.getAttribute('data-unit') || 'pack';
  var UNITS = root.getAttribute('data-units') || UNIT + 's';
  function q(s, el) { return (el || root).querySelector(s); }
  function qa(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function money(c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function perDot(c) {
    if (!COUNT) return '';
    var x = c / COUNT; // cents per dot
    return (x >= 10 ? money(x) : (x < 1 ? x.toFixed(2) : x.toFixed(1)) + '¢');
  }
  function plural(n) { return n === 1 ? UNIT : UNITS; }
  function pop(el) { if (!el) return; el.classList.remove('cls-pop'); void el.offsetWidth; el.classList.add('cls-pop'); }

  var form = q('[data-cls-form]');
  var idInput = q('[data-cls-id]');
  var qtyInput = q('[data-cls-qty]');
  var atc = q('[data-cls-atc]');
  var atcLabel = q('[data-cls-atc-label]');
  var swatches = qa('.cls-sw');
  var variantJson = document.querySelector('script[type="application/json"][data-variant]');
  var cur = null;          // selected swatch dataset
  var tiers = [];          // [{min, pct}] from the live Hulk table
  var inCart = 0;          // units of this product already in the cart (Hulk counts them toward the tier)

  /* ---------------- colors ---------------- */
  function dataOf(btn) {
    var d = btn.dataset;
    return { btn: btn, id: d.id, title: d.title, price: parseInt(d.price, 10), sku: d.sku, avail: d.avail === 'true', hex: d.hex,
      mat: d.mat, group: d.group, img: d.img, srcset: d.srcset, full: d.full, w: d.w, h: d.h, bg: btn.querySelector('.cls-sw__dot').style.backgroundImage };
  }
  function setDot(d) {
    root.style.setProperty('--cls-dot', d.hex || '#ccc');
    var chip = q('.cls-colors__chip');
    if (chip) chip.style.background = d.bg && d.bg !== 'none' ? d.bg + ' center/cover' : d.hex;
    var ss = q('[data-cls-sticky-sw]');
    if (ss) { ss.style.backgroundColor = d.hex; ss.style.backgroundImage = d.bg || ''; }
  }
  function select(btn, user) {
    var d = dataOf(btn);
    cur = d;
    swatches.forEach(function (b) { var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    if (idInput && idInput.value !== d.id) {
      idInput.value = d.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (variantJson) {
      try { var v = JSON.parse(variantJson.textContent); v.id = +d.id; v.price = d.price; v.title = d.title; v.sku = d.sku; v.available = d.avail; variantJson.textContent = JSON.stringify(v); } catch (e) {}
    }
    var name = q('[data-cls-colorname]'); if (name) name.textContent = d.title;
    var sku = q('[data-cls-sku]'); if (sku) sku.textContent = d.sku;
    var mat = q('[data-cls-mat]'); if (mat && cfg.materials) mat.textContent = cfg.materials[d.mat] || '';
    var sc = q('[data-cls-sticky-color]'); if (sc && !sc.hasAttribute('data-cls-keep')) sc.textContent = d.title;
    setDot(d);
    if (atc) {
      atc.disabled = !d.avail;
      if (atcLabel) atcLabel.textContent = d.avail ? 'Add to cart' : 'Sold out';
    }
    if (user) {
      btn.classList.remove('is-new'); void btn.offsetWidth; btn.classList.add('is-new');
      swapPhoto(d);
      try {
        var u = new URL(location.href); u.searchParams.set('variant', d.id);
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }
    renderPrice(user);
  }
  swatches.forEach(function (b) {
    b.addEventListener('click', function () { select(b, true); });
  });
  // arrow keys move through the radio group
  var cg = q('.cls-colors');
  if (cg) cg.addEventListener('keydown', function (e) {
    var i = swatches.indexOf(document.activeElement);
    if (i < 0) return;
    var k = e.key, n = null;
    if (k === 'ArrowRight' || k === 'ArrowDown') n = swatches[(i + 1) % swatches.length];
    if (k === 'ArrowLeft' || k === 'ArrowUp') n = swatches[(i - 1 + swatches.length) % swatches.length];
    if (n) { e.preventDefault(); n.focus(); select(n, true); }
  });
  // price range per group label
  qa('.cls-colors__group').forEach(function (g) {
    var ps = qa('.cls-sw', g).map(function (b) { return parseInt(b.dataset.price, 10); });
    if (!ps.length) return;
    var lo = Math.min.apply(null, ps), hi = Math.max.apply(null, ps);
    var el = q('[data-cls-grange]', g);
    if (el) el.textContent = lo === hi ? money(lo) : money(lo) + '–' + money(hi);
  });

  /* ---------------- price, tiers, totals ---------------- */
  function qty() { var n = parseInt(qtyInput && qtyInput.value, 10); return isNaN(n) || n < 1 ? 1 : Math.min(n, 9999); }
  function tierFor(n) { var t = null; tiers.forEach(function (x) { if (n >= x.min) t = x; }); return t; }
  function unitAt(t) { return t ? Math.round(cur.price * (1 - t.pct / 100)) : cur.price; }
  function renderPrice(animate) {
    if (!cur) return;
    var p = q('[data-cls-price]'); if (p) { p.textContent = money(cur.price); if (animate) pop(p); }
    var per = q('[data-cls-per]');
    if (per) {
      var best = tiers.length ? tiers[tiers.length - 1] : null;
      per.textContent = COUNT ? perDot(cur.price) + ' per dot' + (best ? ' · as low as ' + perDot(unitAt(best)) + ' per dot at ' + best.min.toLocaleString() + '+' : '') : '';
    }
    var sp = q('[data-cls-sticky-price]'); if (sp) sp.textContent = money(cur.price);
    var from = q('[data-cls-from]');
    if (from) {
      if (tiers.length) {
        var t0 = tiers[0];
        from.innerHTML = '<b>' + money(unitAt(t0)) + ' each</b> when you buy ' + t0.min + ' or more (' + t0.pct + '% off). Mix any colors.';
        from.hidden = false;
      } else from.hidden = true;
    }
    renderTiers();
    renderTotal();
  }
  function renderTiers() {
    var box = q('[data-cls-tiers]'), body = q('[data-cls-tiers-body]');
    if (!box || !body || !cur) return;
    if (!tiers.length) { box.hidden = true; return; }
    var n = qty() + inCart, active = tierFor(n);
    var rows = [{ min: 1, pct: 0 }].concat(tiers);
    body.innerHTML = rows.map(function (t, i) {
      var next = rows[i + 1];
      var label = next ? (t.min === next.min - 1 ? String(t.min) : t.min.toLocaleString() + '–' + (next.min - 1).toLocaleString()) : t.min.toLocaleString() + '+';
      var u = t.pct ? Math.round(cur.price * (1 - t.pct / 100)) : cur.price;
      var on = (active ? active.min === t.min : t.min === 1);
      return '<tr data-min="' + t.min + '" class="' + (on ? 'is-on' : '') + '" tabindex="0" aria-label="Set quantity to ' + t.min + '"><td>' + label + '</td><td><b>' + money(u) + '</b></td><td>' + (COUNT ? perDot(u) : '') + '</td><td class="cls-tiers__save">' + (t.pct ? t.pct + '%' : '—') + '</td></tr>';
    }).join('');
    box.hidden = false;
  }
  function renderTotal() {
    var el = q('[data-cls-total]');
    if (!el || !cur) return;
    var n = qty(), all = n + inCart, t = tierFor(all), list = cur.price * n;
    var html = '';
    if (t) {
      var u = unitAt(t), tot = Math.round(cur.price * n * (1 - t.pct / 100)); // Hulk discounts the line total
      html = 'About <b>' + money(tot) + '</b> for ' + n + ' ' + plural(n) + ' at checkout (' + money(u) + ' each), <span class="cls-ok">you save ' + money(list - tot) + '</span>';
    } else {
      html = '<b>' + money(list) + '</b> for ' + n + ' ' + plural(n);
      var nxt = tiers[0];
      if (nxt && all < nxt.min) {
        var need = nxt.min - all;
        html += ' · add ' + need + ' more (any color) to pay <span class="cls-ok">' + money(unitAt(nxt)) + ' each</span>';
      }
    }
    if (inCart) html += '<br><small>Includes ' + inCart + ' ' + plural(inCart) + ' already in your cart toward the volume tier.</small>';
    el.innerHTML = html;
    var lab = atcLabel && cur.avail ? 'Add ' + (n > 1 ? n + ' ' + plural(n) + ' ' : '') + 'to cart' : null;
    if (lab && atcLabel && !atc.classList.contains('is-done')) atcLabel.textContent = lab;
  }
  var tb = q('[data-cls-tiers-body]');
  if (tb) {
    var pickRow = function (tr) { if (!tr) return; qtyInput.value = Math.max(1, parseInt(tr.getAttribute('data-min'), 10) - inCart); renderTiers(); renderTotal(); pop(qtyInput); };
    tb.addEventListener('click', function (e) { pickRow(e.target.closest('tr')); });
    tb.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pickRow(e.target.closest('tr')); } });
  }
  qa('[data-cls-step]').forEach(function (b) {
    b.addEventListener('click', function () { qtyInput.value = Math.max(1, Math.min(9999, qty() + parseInt(b.getAttribute('data-cls-step'), 10))); renderTiers(); renderTotal(); });
  });
  if (qtyInput) {
    qtyInput.addEventListener('input', function () { renderTiers(); renderTotal(); });
    qtyInput.addEventListener('change', function () { qtyInput.value = qty(); renderTiers(); renderTotal(); });
  }

  /* Read the live HulkApps table. Hulk renders percent rows ("Buy 3+ ... 40% Off"); the site-wide
     chromalabel-volume-pricing.js may convert the percent to dollars but keeps it in data-hulk-pct. */
  function readHulk() {
    var host = document.querySelector('.cls-hulk-src .hulkapps-volumes') || document.querySelector('.hulkapps-volumes');
    if (!host) return false;
    var rows = Array.prototype.slice.call(host.querySelectorAll('tr')).filter(function (r) { return r.querySelector('td'); });
    var out = [];
    rows.forEach(function (r) {
      var cells = r.querySelectorAll('td');
      var mq = (cells[0].textContent || '').replace(/,/g, '').match(/\d+/);
      var span = r.querySelector('[data-hulk-pct]');
      var pct = span ? parseFloat(span.getAttribute('data-hulk-pct')) : NaN;
      if (isNaN(pct)) { var m = (r.textContent || '').match(/(\d+(?:\.\d+)?)\s*%/); pct = m ? parseFloat(m[1]) : NaN; }
      if (mq && !isNaN(pct) && pct > 0 && pct < 100) out.push({ min: parseInt(mq[0], 10), pct: pct });
    });
    out.sort(function (a, b) { return a.min - b.min; });
    if (!out.length) return false;
    var same = out.length === tiers.length && out.every(function (t, i) { return t.min === tiers[i].min && t.pct === tiers[i].pct; });
    if (!same) { tiers = out; root.setAttribute('data-tiers', 'live'); renderPrice(false); }
    return true;
  }
  (function watchHulk() {
    var tries = 0;
    var iv = setInterval(function () { tries++; if (readHulk() || tries > 40) clearInterval(iv); }, 250);
    var host = document.querySelector('.cls-hulk-src');
    if (host && 'MutationObserver' in window) new MutationObserver(function () { readHulk(); }).observe(host, { childList: true, subtree: true, characterData: true, attributes: true });
  })();

  function refreshCart() {
    var pid = root.getAttribute('data-product-id');
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var n = 0; (c.items || []).forEach(function (it) { if (String(it.product_id) === String(pid)) n += it.quantity; });
      inCart = n; renderTiers(); renderTotal(); return c;
    }).catch(function () {});
  }

  /* ---------------- add to cart ---------------- */
  // HulkApps tags this button .hulkapps_submit_cart and, from a document-level jQuery handler, cancels the first click
  // and replays it (to validate the HulkApps Product Options app, which this store doesn't use). The replay makes
  // Klaviyo's per-button cart watcher abort its own request ("New cart event" unhandled rejection). Keep the click from
  // bubbling to document, as gem-ajax-cart.js does on the live pages. Button listeners (Klaviyo) and the form submit
  // still run; Hulk's volume table and checkout discount don't depend on this handler.
  if (atc) atc.addEventListener('click', function (e) { e.stopPropagation(); });
  if (form) form.addEventListener('submit', function (e) {
    if (!window.FormData || !window.Promise) return; // plain form post
    e.preventDefault();
    if (!cur || !cur.avail || atc.classList.contains('is-busy')) return;
    qtyInput.value = qty();
    var msg = q('[data-cls-msg]'); msg.textContent = ''; msg.classList.remove('is-err');
    atc.classList.add('is-busy');
    var fd = new FormData(form);
    var n = qty();
    // XHR (not fetch), like the GemPages/jQuery add on the live pages: the site's cart-watching apps (Klaviyo onsite,
    // Hulk, minmaxify) hook it the same way they do today.
    new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', '/cart/add.js');
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        if (x.status === 429) return reject(new Error('Our cart is busy for a moment. Please wait a minute and try again.'));
        var j = null; try { j = JSON.parse(x.responseText); } catch (e) {}
        if (x.status >= 200 && x.status < 300 && j) resolve(j);
        else reject(new Error((j && (j.description || j.message)) || 'Could not add to cart. Please try again.'));
      };
      x.onerror = function () { reject(new Error('Could not reach the cart. Check your connection and try again.')); };
      x.send(fd);
    })
      .then(function (item) {
        atc.classList.remove('is-busy'); atc.classList.add('is-done');
        if (atcLabel) atcLabel.textContent = 'Added \u2713';
        setTimeout(function () { atc.classList.remove('is-done'); renderTotal(); if (atcLabel && n === 1) atcLabel.textContent = 'Add to cart'; }, 2200);
        form.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { variant: item, quantity: n } }));
        // let the theme drawer and cart-watching apps finish their own cart reads first
        setTimeout(function () {
          refreshCart().then(function (c) {
            if (!c) return;
            qa('[data-cart-count]', document).forEach(function (el) { el.textContent = c.item_count; });
          });
        }, 1800);
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'cls_add_to_cart', cls_sku: cur.sku, cls_qty: n }); } catch (x) {}
      })
      .catch(function (err) {
        atc.classList.remove('is-busy');
        msg.textContent = (err && err.message) || 'Something went wrong. Please try again.';
        msg.classList.add('is-err');
      });
  });

  /* ---------------- sticky bar (mobile) ----------------
     Shown whenever the main Add to cart button is out of view (after the first scroll).
     Bottom clearance (--cls-chrome-bottom) keeps the bar's content above browser chrome:
       - visualViewport: how much of the layout viewport is covered right now (toolbar, keyboard);
       - env(safe-area-inset-bottom) (0 here: the theme's meta viewport has no viewport-fit=cover);
       - Safari 26+ on iPhone/iPad: its floating address pill is drawn over the page and is NOT reported by
         either of the above. Measured on Joe's iPhone (iOS 26, collapsed pill): the pill reaches 45 pt above
         the layout-viewport bottom; Safari shrinks the layout viewport when the pill expands, so the same
         clearance holds in both states. The pill floats over the bar's solid lower band.
     The chat bubble is lifted above the bar via Shopify's activator-offset properties (CSS in cl-spec.css). */
  var sticky = q('[data-cls-sticky]');
  var docEl = document.documentElement;
  var ua = navigator.userAgent || '';
  var iOS = /iP(hone|od|ad)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var sv = ua.match(/Version\/(\d+)/);
  var floatingPill = iOS && sv && +sv[1] >= 26 && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua);
  var PILL_CLEARANCE = 54; // 45 pt measured + margin for the taller expanded pill
  var probe = null;
  function safeInset() {
    if (!probe) { probe = document.createElement('div'); probe.style.cssText = 'position:fixed;left:0;bottom:0;width:0;height:0;visibility:hidden;padding-bottom:env(safe-area-inset-bottom,0px)'; document.body.appendChild(probe); }
    return parseFloat(getComputedStyle(probe).paddingBottom) || 0;
  }
  function chromeBottom() {
    var vv = window.visualViewport, covered = 0;
    if (vv && vv.scale < 1.05) covered = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    if (covered > window.innerHeight * 0.4) covered = 0; // on-screen keyboard: ignore
    return Math.max(covered, safeInset(), floatingPill ? PILL_CLEARANCE : 0);
  }
  var stickyOn = false, atcVisible = true;
  function layoutSticky() {
    if (!sticky) return;
    docEl.style.setProperty('--cls-chrome-bottom', chromeBottom() + 'px');
    var h = sticky.offsetHeight;
    // bar + the lifted chat bubble (about 50px + gaps), so the page's last line clears both at the very end
    docEl.style.setProperty('--cls-sticky-space', (stickyOn ? h + 66 : 0) + 'px');
    docEl.style.setProperty('--cls-chat-lift', (h + 10) + 'px');
  }
  function setSticky(show) {
    if (show === stickyOn) return;
    stickyOn = show;
    sticky.classList.toggle('is-on', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    var sb = q('[data-cls-sticky-add]'); if (sb) sb.tabIndex = show ? 0 : -1;
    document.body.classList.toggle('cls-sticky-on', show);
    layoutSticky();
    try { document.dispatchEvent(new CustomEvent('cl:sticky-atc')); } catch (e) {} // site chat keep-clear refreshes
  }
  function evalSticky() { setSticky(!atcVisible && window.scrollY > 200 && window.matchMedia('(max-width: 989px)').matches); }
  if (sticky && atc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { atcVisible = es[0].isIntersecting; evalSticky(); }, { threshold: 0 }).observe(atc);
    window.addEventListener('scroll', evalSticky, { passive: true });
    window.addEventListener('resize', function () { layoutSticky(); evalSticky(); });
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', layoutSticky); window.visualViewport.addEventListener('scroll', layoutSticky); }
    layoutSticky();
    q('[data-cls-sticky-add]').addEventListener('click', function (e) {
      e.stopPropagation();
      if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
    });
  }

  /* ---------------- gallery ---------------- */
  var track = q('[data-cls-track]'), thumbs = q('[data-cls-thumbs]'), countEl = q('[data-cls-count]');
  var slides = track ? qa('.cls-gal__slide', track) : [];
  var active = 0;
  function firstSrc(img) { var s = img.getAttribute('srcset'); if (s) { var f = s.split(',')[0].trim().split(' ')[0]; if (f) return f; } return img.currentSrc || img.src; }
  function buildThumbs() {
    if (!thumbs) return;
    thumbs.innerHTML = '';
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cls-thumb'; b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', i === active ? 'true' : 'false');
      var img = s.querySelector('img');
      if (img) { var t = document.createElement('img'); t.src = firstSrc(img); t.alt = ''; t.loading = 'lazy'; b.appendChild(t); b.setAttribute('aria-label', 'Photo ' + (i + 1) + ': ' + (img.alt || '')); }
      else { b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="8" cy="12" r="5" fill="var(--cls-dot,#ff6128)" stroke="none"/><circle cx="17.5" cy="12" r="3.5"/><path d="M2 20h20M4 20v-2M8 20v-2M12 20v-2M16 20v-2M20 20v-2"/></svg>'; b.setAttribute('aria-label', 'Size guide'); }
      b.addEventListener('click', function () { go(i); });
      thumbs.appendChild(b);
    });
  }
  function setActive(i) {
    active = i;
    if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length;
    if (thumbs) qa('.cls-thumb', thumbs).forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); if (j === i && t.scrollIntoView && thumbs.scrollWidth > thumbs.clientWidth) thumbs.scrollTo({ left: t.offsetLeft - thumbs.clientWidth / 2 + 32, behavior: 'smooth' }); });
    var pv = q('[data-cls-prev]'), nx = q('[data-cls-next]');
    if (pv) pv.disabled = i === 0; if (nx) nx.disabled = i === slides.length - 1;
  }
  function go(i) { if (!track) return; i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); setActive(i); }
  if (track && slides.length) {
    buildThumbs(); setActive(0);
    var st;
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== active) setActive(i); }, 60); }, { passive: true });
    var pv = q('[data-cls-prev]'), nx = q('[data-cls-next]');
    if (pv) pv.addEventListener('click', function () { go(active - 1); });
    if (nx) nx.addEventListener('click', function () { go(active + 1); });
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); } });
    if (slides.length < 2) { qa('.cls-gal__nav').forEach(function (b) { b.hidden = true; }); if (countEl) countEl.hidden = true; }
  }
  function swapPhoto(d) {
    var img = q('[data-cls-colorimg]');
    if (!img || !d.img) return;
    img.src = d.img;
    if (d.srcset) img.srcset = d.srcset; else img.removeAttribute('srcset');
    if (d.w) img.width = d.w; if (d.h) img.height = d.h;
    img.setAttribute('data-full', d.full || d.img);
    img.alt = (q('.cls-title') ? q('.cls-title').textContent : '') + ' – ' + d.title;
    var t0 = thumbs && thumbs.querySelector('.cls-thumb img');
    if (t0) t0.src = d.srcset ? d.srcset.split(',')[0].trim().split(' ')[0] : d.img;
    if (active !== 0) go(0);
  }

  /* ---------------- zoom viewer ---------------- */
  var lb = q('[data-cls-lb]'), stage = q('[data-cls-lb-stage]');
  function openZoom(btn) {
    if (!lb || !lb.showModal) return;
    var img = btn.querySelector('img');
    stage.innerHTML = '';
    if (img) {
      var big = document.createElement('img');
      big.src = img.getAttribute('data-full') || img.currentSrc || img.src; big.alt = img.alt || '';
      stage.appendChild(big);
    } else {
      var svg = btn.querySelector('svg'); if (svg) stage.appendChild(svg.cloneNode(true));
    }
    lb.classList.remove('is-zoom');
    lb.showModal();
    document.documentElement.style.overflow = 'hidden';
  }
  qa('[data-cls-zoom]').forEach(function (b) { b.addEventListener('click', function () { openZoom(b); }); });
  if (lb) {
    lb.addEventListener('close', function () { document.documentElement.style.overflow = ''; stage.innerHTML = ''; });
    q('[data-cls-lb-close]').addEventListener('click', function () { lb.close(); });
    var setOrigin = function (e) {
      var el = stage.firstElementChild; if (!el) return;
      var r = stage.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100)), y = Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100));
      el.style.transformOrigin = x + '% ' + y + '%';
    };
    stage.addEventListener('click', function (e) {
      var el = stage.firstElementChild; if (!el) return;
      var z = !lb.classList.contains('is-zoom');
      lb.classList.toggle('is-zoom', z);
      setOrigin(e);
      el.style.transform = z ? 'scale(2.6)' : '';
    });
    stage.addEventListener('pointermove', function (e) { if (lb.classList.contains('is-zoom')) setOrigin(e); });
  }

  /* ---------------- init ---------------- */
  var on = swatches.filter(function (b) { return b.classList.contains('is-on'); })[0] || swatches[0];
  if (on) select(on, false);
  refreshCart();
})();
